import { Component, Input, Output, EventEmitter, OnInit } from 'ng-metadata/core';
import './match-sentence.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentMatchSentence
 * @module mw.components.contentDocuments
 *
 * @param {string[]} [text] - A document title.  This can be an HTML string.
 *
 * @description
 * `<mw-content-document-match-sentence>` provides a means for displaying the title of a content document.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Using transclusion -->
 *   <mw-content-document-match-sentence text="$ctrl.matchSentence"></mw-content-document-match-sentence>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-match-sentence',
    template: `
        <div class="mw-content-document-match-sentence" ng-repeat="text in ::$ctrl.text" ng-bind-html="::(text | mwSanitizeInvalidHtml | mwLinkyHtml)"></div>
    `,
    legacy: {
        transclude: true
    }
})
export class MatchSentenceComponent implements OnInit {
    @Input('<') text: string[];

    constructor() {
        'ngInject';
    }

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/match-sentence/match-sentence.component.ts